import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const twilio = defineConnector({
  identifier: "twilio",
  name: "Twilio",
  tagLine: "SMS, voice, and messaging",
  keywords: "sms mms text texting phone numbers calls programmable",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.twilio\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.accountSid,
      password: app.secret.authToken,
    }),
  steps: [
    {
      title: "Get your Twilio credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the [Twilio Console](https://console.twilio.com/) and navigate to your account dashboard.\n\nYou'll find your **Account SID** and **Auth Token** on the main dashboard page.",
        },
      ],
    },
    {
      title: "Enter your Account SID",
      items: [
        {
          kind: "markdown",
          content:
            "Your Account SID is the unique identifier for your Twilio account. It starts with `AC`.",
        },
        {
          kind: "input",
          label: "Account SID",
          placeholder: "AC...",
          required: true,
          target: { kind: "configuration", field: "accountSid" },
        },
      ],
    },
    {
      title: "Enter your Auth Token",
      items: [
        {
          kind: "markdown",
          content:
            "Your Auth Token is the secret key used to authenticate API requests.\n\n**Keep this token secret** — anyone with access can make API calls on your behalf.",
        },
        {
          kind: "input",
          label: "Auth Token",
          placeholder: "Paste your auth token",
          required: true,
          target: { kind: "secrets", field: "authToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ accountSid }) =>
      `https://api.twilio.com/2010-04-01/Accounts/${accountSid}.json`,
  },
});
